<script lang="ts">
  import App from "website_script/App.svelte"
  import AppContainer from "website_script/App/AppContainer.svelte"
  import type { Theme } from "website_script/types/theme"
  import type { Texts } from "website_script/types/texts"
  import type { Settings } from "website_script/types/settings"
  import type { Config } from "website_script/types/common"
  export let theme: Theme
  export let texts: Texts
  export let settings: Settings
  /** The AuEmbed.config object - settings (such as callbacks) set from the website */
  export let config: Config
</script>

<AppContainer {theme} {texts} {settings} {config}>
  <App />
</AppContainer>
